import React, { useState } from 'react';
import * as PropTypes from 'prop-types';

import loginValidator from '../../../../../utils/validations/loginValidator';
import { IDS } from '../../../../../constants/ids';
import ErrorBlock from '../../../../common/ErrorBlock';
import TextInput from '../../../../TextInput';
import Popup from '../../../../common/Popup';
import Button from '../../../../Button';
import { getSafeUserId } from '../../utils';
import { enhance } from './enhance';
import styles from './index.styl';

function ShareToEmailModal({
  intl: { formatMessage },
  openedShareToEmailModal,
  targetUserId,
  shareToEmail,
  documentUid,
  mainUserId,
  close,
}) {
  const [email, setEmail] = useState('');
  const [emailError, setEmailError] = useState('');
  const [confirmationView, setConfirmationView] = useState(false);

  const { safeUserId } = getSafeUserId(targetUserId, mainUserId);

  const handleCloseModal = () => {
    setEmailError('');
    setEmail('');
    close();
  };

  const resetEmailError = () => {
    if (emailError) setEmailError('');
  };

  const isValidEmail = value => {
    const isValid = value ? loginValidator(value) : true;
    if (!isValid) {
      setEmailError(
        formatMessage({
          id: 'patient.portal.healthRecord.shareToEmail.validationMsg',
        }),
      );
    }
    return isValid;
  };

  const handleOnChangeEmail = value => {
    setEmail(value);
  };

  const handleShareToEmail = () => {
    handleCloseModal();
    setConfirmationView(false);
    shareToEmail({ userId: safeUserId, email, document_uid: documentUid });
  };

  return confirmationView ? (
    <Popup
      onClose={() => setConfirmationView(false)}
      opened={confirmationView}
      mobileFullScreen={false}
      overflowVisible
      withoutAdaptive
      withHeading={false}
      strictClose
    >
      <div className={styles.confirmationView}>
        <div className={styles.confirmationContentWrapper}>
          <div className={styles.confirmationContent}>
            {formatMessage(
              { id: 'patient.portal.healthRecord.shareToEmail.confirmTitle' },
              { recipient: email },
            )}
          </div>
          <div className={styles.confirmationContent}>
            {formatMessage({
              id: 'patient.portal.healthRecord.shareToEmail.confirmQuestion',
            })}
          </div>
        </div>
        <div className={styles.confirmationButtonWrapper}>
          <Button
            id={IDS.COMMON.ACTION_CONFIRMATION_SUBMIT}
            color="primary"
            onClick={handleShareToEmail}
            children={formatMessage({
              id: 'patient.portal.healthRecord.shareToEmail.confirmButton',
            })}
            type="button"
            className={styles.actionButton}
            raised
          />
          <Button
            id={IDS.COMMON.ACTION_CONFIRMATION_CANCEL}
            color="accent"
            raised
            type="button"
            onClick={() => setConfirmationView(false)}
            className={styles.actionButton}
            children={formatMessage({ id: 'common.cancel' })}
          />
        </div>
      </div>
    </Popup>
  ) : (
    <Popup
      title={formatMessage({ id: 'patient.portal.healthRecord.shareToEmail' })}
      onClose={handleCloseModal}
      opened={openedShareToEmailModal}
      mobileFullScreen={false}
      overflowVisible
      withoutAdaptive
      strictClose
    >
      <div className={styles.root}>
        <div className={styles.description}>
          {formatMessage({
            id: 'patient.portal.healthRecord.shareToEmail.description',
          })}
        </div>
        <TextInput
          className={styles.inputEmail}
          id={IDS.PATIENT_PORTAL.TAB_HEALTH_RECORD.SHARE_TO_EMAIL_INPUT}
          label={formatMessage({
            id: 'patient.portal.healthRecord.shareToEmailRecipient',
          })}
          name="email"
          placeholder={formatMessage({
            id: 'patient.portal.healthRecord.shareToEmailRecipient',
          })}
          onChange={val => handleOnChangeEmail(val)}
          onBlur={val => isValidEmail(val)}
          onFocus={resetEmailError}
          value={email}
        />
        {email && emailError && (
          <ErrorBlock errors={emailError} className={styles.errorBlock} />
        )}
        <div className={styles.actionButtonWrapper}>
          <Button
            id={IDS.COMMON.ACTION_CONFIRMATION_SUBMIT}
            color="primary"
            onClick={() => setConfirmationView(true)}
            children={formatMessage({ id: 'common.send' })}
            disabled={!email || !!emailError}
            type="button"
            className={styles.actionButton}
            raised
          />
          <Button
            id={IDS.COMMON.ACTION_CONFIRMATION_CANCEL}
            color="accent"
            raised
            type="button"
            onClick={handleCloseModal}
            className={styles.actionButton}
            children={formatMessage({ id: 'common.cancel' })}
          />
        </div>
      </div>
    </Popup>
  );
}

ShareToEmailModal.propTypes = {
  intl: PropTypes.object,
  close: PropTypes.func,
  openedShareToEmailModal: PropTypes.bool,
  mainUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  targetUserId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  shareToEmail: PropTypes.func,
  documentUid: PropTypes.string,
};

export default enhance(ShareToEmailModal);



// WEBPACK FOOTER //
// ./src/components/PatientHealthboard/PatientPortal/DataList/ShareToEmailModal/index.jsx